import { After202305Strategy, Before202305Strategy, PlanNameContext } from '@/service/facility/getPlanName';
import { isBetaFacility } from '@/service/facility/isBetaFacility';

angular
  .module('inspinia')
  .factory('facilityService', function (agenciesService, authoritiesService, attributesService) {
    let data = {
      // 施設情報
      facility: {},
      // 施設の経由元の施設情報
      manageFacility: {},
      // 兄弟施設ID一覧
      groupServiceIds: [],
    };

    // Getters

    /**
     * 施設情報取得
     * @returns {object} 施設
     */
    const getFacility = () => {
      return data.facility;
    };

    /**
     * 施設ID取得
     * @returns {string} 施設ID
     */
    const getFacilityId = () => {
      return data.facility.facilityId;
    };

    /**
     * 兄弟施設ID一覧取得
     * @returns {array} 兄弟施設一覧
     */
    const getGroupServiceIds = () => {
      return data.groupServiceIds;
    };

    /**
     * 親施設ID取得
     * @returns {string} 親施設ID
     */
    const getManageFacilityId = () => {
      return data.manageFacility.manageFacilityId;
    };

    /**
     * 動画配信の特約規約に同意しているかどうか
     * @returns {boolean}
     */
    const getHasVideoTermsAgreement = () => {
      // 本当は権限じゃないからauthoritiesにはおきたくないけど一旦
      return authoritiesService.getAuthorities()['agree_to_video_streaming_terms'] === '1' || false;
    };

    /**
     * 再販代理店経由施設かどうか
     * @returns {boolean}
     */
    const getIsViaResaleAgencyFacility = () => {
      if (!agenciesService.getResaleAgencies().length) return false;
      return agenciesService
        .getResaleAgencies()
        .some((resaleAgency) => resaleAgency && resaleAgency['id'] === getManageFacilityId());
    };

    /**
     * 直販かどうか
     * TODO: 一旦、再販代理店経由施設ではないという条件にしておく。正しい条件で後から実装
     * @returns {boolean}
     */
    const getIsDirectAgencyFacility = () => {
      return !getIsViaResaleAgencyFacility();
    };

    /**
     * 再販代理店施設かどうか
     * @returns {boolean}
     */
    const getIsResaleAgencyFacility = () => {
      if (!agenciesService.getResaleAgencies().length) return false;
      return agenciesService
        .getResaleAgencies()
        .some((resaleAgency) => resaleAgency && resaleAgency['id'] === getFacilityId());
    };

    const getPlanName = () => {
      const planId = parseInt(data.facility.planId, 10);
      const planNameStrategy =
        new Date() < new Date(2023, 4, 1)
          ? new Before202305Strategy(planId)
          : new After202305Strategy(planId, attributesService.isMainFacility(), attributesService.usePackplan());
      const context = new PlanNameContext(planNameStrategy);
      return context.getPlanName();
    };

    // Mutations

    /**
     * APIの施設情報をフォーマットして持っておく
     * @param {*} facility APIで取得した施設情報
     */
    const setFacility = (facility) => {
      data.facility = {
        facilityId: facility.id,
        facilityName: facility.sender_name,
        planId: facility.plan_id,
      };
    };

    /**
     * @param {*} groupServiceIds 兄弟施設一覧
     */
    const setGroupServiceIds = (groupServiceIds) => {
      data.groupServiceIds = groupServiceIds;
    };

    /**
     * @param {*} manageFacility 管理施設
     */
    const setManageFacility = (manageFacility) => {
      const { manage_service, group_service_id } = manageFacility;
      const { id, name } = manage_service;
      setGroupServiceIds(group_service_id);
      data.manageFacility = {
        manageFacilityId: id,
        manageFacilityName: name,
      };
    };

    /**
     * NOTE: 学童の役職名対応が全開放になったタイミングでこの関数も削除する。
     * manage/js/controller/appCtrl.js はモジュール化されていない為、isBetaFacility をインポートすることができない。
     * checkLanguageByService をappCtrl.js から切り出した際の影響が多いことから、サービス経由でisBetaFacility を呼ぶようにした。
     */
    const isBetaFacilityByFeatureName = (featureName) => {
      return isBetaFacility(featureName);
    };

    // Actions

    /**
     * 初期化処理
     * @param {*} facility APIで取得した施設情報
     */
    const initialize = async (facility) => {
      setFacility(facility);
      attributesService.setAttributes(facility.attributes);
    };

    return {
      ...data,
      getFacility,
      getFacilityId,
      getGroupServiceIds,
      getManageFacilityId,
      getHasVideoTermsAgreement,
      getIsDirectAgencyFacility,
      getIsResaleAgencyFacility,
      getIsViaResaleAgencyFacility,
      getPlanName,
      setFacility,
      setGroupServiceIds,
      setManageFacility,
      isBetaFacilityByFeatureName,
      initialize,
    };
  });
